export function setMessagePaneVisible(visible) {
    try {
        document.getElementsByClassName('inputValidationMsgPane')[0].style.display = visible
            ? 'block'
            : 'none';
    } catch (e) {}
}
